exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ab-container[data-v-962b6598]{position:relative;z-index:4;background:#f3f9ff}.ab-container[data-v-962b6598] .drag-tool{padding:0 !important;background:#f3f9ff}.ab-container[data-v-962b6598] .drag-box{min-height:177px;position:relative;z-index:2;background:#f3f9ff;padding:0 20px 10px 20px}.ab-empty[data-v-962b6598]{position:absolute;top:0;left:0;background-color:#f4f9fe;text-align:center;padding:61px 0;width:100%}.ab-empty div[data-v-962b6598]{font-weight:700;line-height:13px;font-size:14px;margin-bottom:6px}.ab-empty span[data-v-962b6598]{color:#999}\n", ""]);

// exports
